import PropTypes from "prop-types";
import React from "react";
import { Link } from "react-router-dom";

import ActionButton from "./ActionButton";

const ModalButtonPanel = ({
  cancelButtonTxt,
  onSubmit,
  submitButtonTxt,
  disabled,
  inProgress,
  parentUrl
}) => (
  <div className="l-flex-end-centered">
    <Link
      to={parentUrl}
      style={{ marginRight: "0.5rem" }}
      className="p-button u-no-margin--bottom"
    >
      {cancelButtonTxt}
    </Link>
    <ActionButton
      onKeyPress={onSubmit}
      onClick={onSubmit}
      disabled={disabled}
      type="positive"
      inProgress={inProgress}
    >
      {submitButtonTxt}
    </ActionButton>
  </div>
);

ModalButtonPanel.propTypes = {
  parentUrl: PropTypes.string.isRequired,
  cancelButtonTxt: PropTypes.string,
  onSubmit: PropTypes.func.isRequired,
  submitButtonTxt: PropTypes.string,
  disabled: PropTypes.bool,
  inProgress: PropTypes.bool
};

ModalButtonPanel.defaultProps = {
  cancelButtonTxt: "Cancel",
  submitButtonTxt: "Save",
  disabled: false,
  inProgress: false
};

export default ModalButtonPanel;
